import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ColorCircleComponent} from './color-circle.component';
import {ColorsPickerComponent} from '../../blocks/block/block-settings/color-picker/colors-picker.component';
import {ColorSketchModule} from 'ngx-color/sketch';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {TranslocoModule} from '@ngneat/transloco';
import {faCheck} from '@fortawesome/pro-solid-svg-icons';
import {DropdownModule} from '@paperlessio/sdk/components/dropdown';

@NgModule({
  declarations: [
    ColorCircleComponent,
    ColorsPickerComponent
  ],
  imports: [
    CommonModule,
    ColorSketchModule,
    FontAwesomeModule,
    TranslocoModule,
    DropdownModule
  ],
  exports: [
    ColorCircleComponent,
    ColorsPickerComponent
  ]
})
export class ColorCircleModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faPlus, faCheck);
  }

}
